import React, { Component } from 'react';
import { connect } from 'react-redux';
import Heading from '../Heading';
import FontAwesome from 'react-fontawesome';
import { COSYND__GUIDE_URL } from '../../constants';
import music from '../../assets/music.svg';
import photo from '../../assets/photo.svg';
import text from '../../assets/text.svg';
import video from '../../assets/video.svg';
import actions from '../../redux/actions';

class ProductType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTitle: [false, false, false],
    };
  }

  componentDidMount() {
    this.props.resetTeam();
    this.props.resetAgreement();
  }

  handleClick(type) {
    this.props.assignAttribute('agreementStartType', this.props.route.type);
    this.props.assignAttribute('type', type);
    this.props.assignAttribute('subtype', '');
    this.props.router.push('/create/product-props');
  }

  handleShowTitle(e, index) {
    e.preventDefault();

    let { showTitle } = this.state;
    showTitle[index] = !showTitle[index];
    this.setState({ showTitle });
  }

  render() {
    const { showTitle } = this.state;

    return (
      <div className="product-type">
        <Heading
          text={
            this.props.route.type === 'new'
              ? 'Create A New Agreement'
              : 'Add Works To An Existing Agreement'
          }
        />

        <h2>First, tell us about what you created (choose one):</h2>
        <br />
        <div className="types">
          {this.props.workTypes.map((workType, i) => {
            let src = null;
            let title = '';
            switch (workType.name) {
              case 'Music':
                src = music;
                title = workType.name;
                break;
              case 'Video':
                src = video;
                title = workType.name;
                break;
              case 'Image':
                src = photo;
                title = workType.name;
                break;
              case 'Document':
                src = text;
                title = 'Literature';
                break;
              default:
                break;
            }
            return (
              <div key={i} onClick={() => this.handleClick(workType.id)}>
                <img src={src} alt={title} />
                <h1>{title}</h1>
              </div>
            );
          })}
        </div>
        <br />

        <p>
          You and your team can create agreements together and add new titles to
          your agreements at any time with Cosynd. Cosynd invites your
          collaborators to verify their ownership split of your copyrights and
          to agree to the terms that you set. We'll walk you and your team
          through customizing your agreement together.
        </p>
        <br />

        <h1 className={`title ${!showTitle[0] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 0)}>
            {showTitle[0] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            What should I have before I start?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[0] ? 'expanded' : 'collapsed'}`}>
          <ol>
            <li>The full legal name of your collaborators.</li>
            <li>Each collaborator’s role (e.g. producer, writer, etc.).</li>
            <li>
              An idea of the ownership split you want to propose to each
              collaborator.
            </li>
          </ol>
          <p>
            Your agreement will be saved after you have entered all of the
            information that we need.&nbsp;
            <a href={COSYND__GUIDE_URL} target="_blank">
              Want to learn more about how it works before you start? Check out
              these short guides.
            </a>
          </p>
        </div>

        <h1 className={`title ${!showTitle[1] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 1)}>
            {showTitle[1] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            What kind of agreements can I create?
          </a>
        </h1>
        <div className={`sub-title ${showTitle[1] ? 'expanded' : 'collapsed'}`}>
          <ul>
            <li>
              <strong>Split Sheet Agreements</strong> - A short document that
              lists the percentage each collaborator owns in your work.
            </li>
            <li>
              <strong>Premium Ownership Agreements</strong> - In addition to
              ownership, establish extremely important details about your
              content such as which collaborators can license your content, who
              may use your name and likeness, how disputes are handled, and
              more.
            </li>
            <li>
              <strong>Work for Hire Agreements</strong> - outlines the scope and
              terms of work to be completed by someone you have paid to help
              create your content such as a contractor, freelancer, etc. This
              agreement is typically used when the person you have paid will not
              be a co-owner of your content.
            </li>
            <li>
              <strong>Producer Agreements</strong> - outlines the scope, terms
              of work, and ownership details between you and a producer
              regarding the production of a song.
            </li>
          </ul>
        </div>

        <h1 className={`title ${!showTitle[2] && 'collapsed-title'}`}>
          <a onClick={(e) => this.handleShowTitle(e, 2)}>
            {showTitle[2] ? (
              <FontAwesome name="caret-up" />
            ) : (
              <FontAwesome name="caret-down" />
            )}
            Why do I need an agreement
          </a>
        </h1>
        <div className={`sub-title ${showTitle[2] ? 'expanded' : 'collapsed'}`}>
          <p>
            If you plan to sell, license or otherwise monetize your content,
            protecting your intellectual property is the most important and
            critical step that you can take - especially if you’re working with
            collaborators. Here’s why:
          </p>
          <ol className="number-list">
            <li>
              Without an agreement in place, each of your collaborators by
              default will own an equal share of the content you create together
              regardless of how minor or major their contribution is.
            </li>
            <li>
              When you want to sell or license your content via a third party
              partner, you will likely need to disclose the owners of the
              content and their respective shares. You may also need to obtain
              permission from your collaborators to enter into an agreement with
              third parties. This is easier to do when you have agreements that
              establish ownership beforehand.
            </li>
          </ol>
          <p>
            Establishing and protecting ownership of your content now can save
            you time, money and the frustration of content-related issues (e.g.
            lawsuits, arguments, loss of income, etc.) in the future.
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  workTypes: state.global.workTypes,
});

const mapDispatchToProps = (dispatch) => ({
  resetTeam: () => {
    dispatch(actions.selectTeam(null));
  },
  resetAgreement: () => {
    dispatch(actions.selectAgreement(null));
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductType);



// WEBPACK FOOTER //
// src/components/Create/ProductType.jsx